<div id="loading-indicator">
    <div class="lds-hourglass"></div>
  </div>
